<template>
  <div class="eu-pa_3 eu-pa_5_md">
    <div class="eu-flex eu-pb_5" v-for="(item, index) in items" :key="index">
      <span class="summary-title eu-flex-item eu-basis_12 eu-basis_12_md eu-pb_3">{{ item.name || `Item ${index+1}`}}</span>
      <span class="summary-label eu-flex-item eu-basis_12 eu-basis_12_md">{{ itemAmountToCurrency(item.amount) }} <span class="summary-content">(x {{ item.default_quantity }} und.)</span></span>
    </div>
    <div class="eu-flex eu-justify_begin">
      <span class="info-label eu-flex-item">{{ $t('itemsLabel') }}</span>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/validations'
export default {
  name: 'Items',
  computed: {
    items () {
      return this.$store.getters.paymentLinkItems
    }
  },
  methods: {
    itemAmountToCurrency (amount) {
      return formatCurrency(amount / 100)
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "itemsLabel": "Você pode adicionar até 10 itens diferentes"
  },
  "en-US": {
    "itemsLabel": "You can add up to 10 different items"
  }
}
</i18n>
